import * as React from 'react'
import { Backdrop } from './Backdrop'

import '../styles/LoadingSpinner.scss'

export interface LoadingSpinnerProps {
    show: boolean
    classes?: string
    text?: string
}

export class LoadingSpinner extends React.Component<LoadingSpinnerProps, {}> {
    render() {
        let classes = this.props.classes ? this.props.classes : ''

        return (
            <Backdrop show={this.props.show} classes={classes}>
                {
                    this.props.text ?
                        <div className="preloaderModal">
                            <p>{this.props.text}</p>
                            <div className="spinner" />
                        </div>
                        :
                        <div className="spinner" />
                }
            </Backdrop>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.tsx